import { create } from "zustand";
import { persist } from 'zustand/middleware';

const useReservationStore = create(
  persist(( set, get ) => ({
    reservations: [],
    setReservations: (value) => set({ reservations: value }),
    updateReservation: (updatedReservation) => set((state) => ({
      reservations: state.reservations.map((reservation) => reservation.id === updatedReservation.id ? { ...reservation, ...updatedReservation } : reservation)
    })),
    addReservation: (reservation) => set((state) => ({
      reservations: [reservation, ...state.reservations]
    })),
    removeReservation: (removedReservation) => set((state) => ({
      reservations: state.reservations.filter((reservation) => removedReservation.id !== reservation.id)
    })),
    reservationsByOrderId: (orderId) => get().reservations.filter((r) => r.order_id == orderId),
    reservationById: (id) => get().reservations.find((r) => r.id == id),
  }), {
    name: 'reservation-storage', // unique name
  })
);

export default useReservationStore;